import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";

export default function Lab() {
  const { t } = useLang();
  const L = t.lab;
  return (
    <section
      id="lab"
      data-testid="lab-section"
      className="relative border-b border-white/10 overflow-hidden"
    >
      <div className="absolute inset-0">
        <div className="absolute inset-0 grid-lines opacity-40" />
        <div className="absolute inset-0 noise" />
        {/* Subtle radial accent on the right */}
        <div
          className="absolute inset-y-0 right-0 w-2/3 opacity-20"
          style={{
            background:
              "radial-gradient(circle at 70% 50%, rgba(255,51,51,0.18) 0%, transparent 55%)",
          }}
        />
      </div>

      <div className="relative max-w-[1440px] mx-auto px-6 lg:px-10 py-28 lg:py-40 grid grid-cols-12 gap-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="col-span-12 lg:col-span-7"
        >
          <div className="label-mono mb-4">{L.label}</div>
          <h2 className="display-2 text-4xl md:text-5xl lg:text-6xl text-white">
            {L.title_a}
            <br />
            {L.title_b}
            <br />
            <span className="text-[#FF3333]">{L.title_accent}</span>
          </h2>

          <p className="mt-10 text-white/70 text-base md:text-lg max-w-xl leading-relaxed">
            {L.body}
          </p>

          <div className="mt-12 border border-white/15 bg-[#101012]/70 backdrop-blur-md">
            {L.facilities.map((f, i) => (
              <div
                key={i}
                className={`flex items-center gap-5 p-5 ${
                  i < L.facilities.length - 1 ? "border-b border-white/10" : ""
                }`}
              >
                <span className="font-mono text-[10px] tracking-widest uppercase text-[#FF3333] w-10">
                  F.{String(i + 1).padStart(2, "0")}
                </span>
                <span className="text-white/85 text-sm">{f}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
